import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { TEST_IDS } from "../constants/testIds";
import { useLang } from "../context/LangContext";
import { translations } from "../lib/i18n";

const AdminLogin = () => {
  const { user, login, checking } = useAuth();
  const nav = useNavigate();
  const { lang } = useLang();
  const t = translations[lang].admin;
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (checking) return <div className="min-h-screen bg-[#0b0d0f]" />;
  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Signed in");
      nav("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0b0d0f] flex items-center justify-center px-6">
      <form
        data-testid={TEST_IDS.admin.loginForm}
        onSubmit={submit}
        className="w-full max-w-md rp-card p-10"
      >
        <div className="text-[10px] tracking-[0.3em] uppercase text-[color:var(--rp-accent)] mb-3">
          Admin
        </div>
        <h1 className="font-display font-extrabold text-white text-3xl mb-8 tracking-tight">
          {t.loginTitle}
        </h1>
        <div className="space-y-6">
          <div>
            <label className="text-[10px] tracking-[0.28em] uppercase text-[color:var(--rp-muted)]">
              {t.email}
            </label>
            <input
              data-testid={TEST_IDS.admin.email}
              type="email"
              className="rp-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
            />
          </div>
          <div>
            <label className="text-[10px] tracking-[0.28em] uppercase text-[color:var(--rp-muted)]">
              {t.password}
            </label>
            <input
              data-testid={TEST_IDS.admin.password}
              type="password"
              className="rp-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
        </div>
        <button
          data-testid={TEST_IDS.admin.submit}
          type="submit"
          disabled={loading}
          className="rp-btn rp-btn-primary w-full mt-10 disabled:opacity-60"
        >
          {loading ? "..." : t.login}
        </button>
        <div className="mt-6 text-center">
          <a href="/" className="text-[11px] tracking-[0.24em] uppercase text-[color:var(--rp-muted)] hover:text-white">
            ← Back to site
          </a>
        </div>
      </form>
    </div>
  );
};

export default AdminLogin;
